import React from 'react';
import autoBind from 'react-autobind';

import Switch, { Case } from 'react-switch-case';
import ReactAudioPlayer from 'react-audio-player';

import Config from "composer/Config.jsx";

import {
  Chip,
  Avatar,
  Icon,
} from '@material-ui/core';

import {
  grey,
  green,
  red,
} from '@material-ui/core/colors';

class SubmissionDetailContent extends React.Component {
  constructor(props) {
    super(props);
    this.refs = React.createRef();

    // state variables here
    this.state = {
      // aNumber : 1,
      // aString: "abc",
      // anArray: [],
      // anObject: {},
      answerData: this.props.answerData,
      ansArr: [],
    };
    autoBind(this);

    if (this.state.answerData.kind == 2) {
      this.state.ansArr = JSON.parse(this.state.answerData.payload).ans_arr;
    }
  }

  render() {
    return (
      <div>
        <Switch condition={this.state.answerData.kind}>
          <Case value={"2"}>
            {this.state.ansArr.map( (row, i) => {
              // compare int, but in string casted
              let isUserSelected = (this.state.answerData.answer + "" == i + "");
              // console.log("isUserSelected " + isUserSelected);
              let isUserCorrect = (isUserSelected && row.is_correct);

              let colorBG = grey[600]; // grey = wrong answer // green = right answer
              let resultBG = colorBG;
              if (!isUserSelected) {
                // result color = normal
              }
              else {
                if (isUserCorrect) {
                  resultBG = green[600];
                }
                else {
                  resultBG = red[600];
                }
              }

              return (
                <Chip
                  style={{margin:"0 12px 0 0", background:resultBG, color:'White'}}
                  avatar={
                    <Avatar style={{background:resultBG}}>
                      <Icon style={{color:'White'}}>{row.is_correct > 0 ? "check_circle": "highlight_off"}</Icon>
                    </Avatar>
                  }
                  label={row.text + (isUserSelected? " [User's choice]" : "")}
                />
              );
            })}
          </Case>
          <Case value={"4"}>
            <ReactAudioPlayer
              src={Config.BASE_PATH()+ this.state.answerData.file_path}
              autoPlay={false}
              loop={false}
              controls={true}
              preload={"auto"}
            />
          </Case>
        </Switch>
      </div>
    )
  }
}

export default SubmissionDetailContent;
